<template>
  <div class="create-com-size">
    <div class="breadcrumb" style="background: #fff" @click="asd">{{ $route.query.id ? '编辑条码' : '创建条码' }}</div>
    <div class="order-detail-basic">
      <el-form hide-required-asterisk ref='ruleForm' :model="SpuBarCodeVo" :rules="rules" label-width="130px">
        <el-form-item label="码名称:" prop="barName">
          <el-input v-model="SpuBarCodeVo.barName"></el-input>
        </el-form-item>
        <el-form-item label="码类型:" prop='codeType'>
          <el-select clearable v-model="SpuBarCodeVo.codeType" @change="change" placeholder="请选择">
            <el-option label="条形码" value="BAR_CODE"></el-option>
            <el-option label="二维码" value="QR_CODE"></el-option>
            <el-option label="标识" value="IDENTITY"></el-option>
            <el-option label="锁线条码" value="LOCKWIRE_BAR_CODE"></el-option>
            <el-option label="上下条码" value="VERTICAL_BAR_CODE"></el-option>
            <el-option label="祝福墙二维码" value="BLESSING_WALL_QR_CODE"></el-option>
            <el-option label="客户备注" value="REMARK"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格:">
          <div style="display: flex">
            <div class="spec-mm" v-if="SpuBarCodeVo.codeType === 'REMARK'">
              <el-form-item label="字号" prop='fontSize' style="margin:0" label-width="50px">
                <el-input placeholder="" v-model="SpuBarCodeVo.fontSize" @input="input">
                </el-input>
              </el-form-item>
            </div>
            <div class="spec-mm" v-if="SpuBarCodeVo.codeType !== 'REMARK'">
              <el-form-item label="宽度:" prop='width' style="margin:0" label-width="50px">
                <el-input placeholder="" v-model="SpuBarCodeVo.width" @input="input">
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="spec-mm" v-if="SpuBarCodeVo.codeType !== 'REMARK'">
              <el-form-item label="高度:" prop='height' style="margin:0" label-width="50px">
                <el-input placeholder="" v-model="SpuBarCodeVo.height">
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="spec-mm" v-if="SpuBarCodeVo.codeType === 'VERTICAL_BAR_CODE'">
              <el-form-item label="字号" prop='fontSize' style="margin:0" label-width="50px">
                <el-input placeholder="" v-model="SpuBarCodeVo.fontSize" @input="input">
                </el-input>
              </el-form-item>
            </div>
            <div class="spec-mm">
              <el-form-item label="" prop='portrait' style="margin:0" label-width="0">
                <el-input style="width:200px" placeholder="" v-model="SpuBarCodeVo.portraitParam">
                  <template slot="prepend" style="width:60px">
                    <el-select v-model="SpuBarCodeVo.portrait" style="width:77px;overflow:hidden" placeholder="选择">
                      <el-option label="距上" value="top" v-show="SpuBarCodeVo.codeType !== 'REMARK'"></el-option>
                      <el-option label="距下" value="bottom"></el-option>
                    </el-select>
                  </template>
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="spec-mm">
              <el-form-item label="" prop='transverse' style="margin:0" label-width="0">
                <el-input style="width:200px" placeholder="" v-model="SpuBarCodeVo.transverseParam">
                  <template slot="prepend">
                    <el-select v-model="SpuBarCodeVo.transverse" style="width:77px;overflow:hidden" placeholder="选择">
                      <el-option label="距左" value="left"></el-option>
                      <el-option label="距右" value="right" v-show="SpuBarCodeVo.codeType !== 'REMARK'"></el-option>
                    </el-select>
                  </template>
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="标识图片:" v-show="SpuBarCodeVo.codeType === 'IDENTITY'">
          <input id="update" @change="uploadImg" type="file" style="display:none">
          <el-button type="primary" @click="clickInput" round>上传</el-button>
          <img :src="SpuBarCodeVo.identityImage" v-show="SpuBarCodeVo.identityImage !== ''" alt="" style="display:block;width:50px;height:50px;margin-top:10px;">
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="saveCode">保存</el-button>
    </div>
  </div>
</template>
<script>
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg.js'
import { barDetail, barUpdate, barAdd, barUsable } from '@/api/pms'
export default {
  name: 'create-com-size',
  data () {
    var checkSize = (rule, value, callback) => {
      //  );
      if (value === '') {
        callback(new Error('请填写字号'))
      } else if (+value < 12) {
        callback(new Error('字号不能小于12'))
      } else if (+value > 60) {
        callback(new Error('字号不能小于60'))
      } else
        if (!/^([1-9]\d*|[0]{1,1})$/.test(value)) {
          callback(new Error('请输入数字'))
        } else {
          callback()
        }
    }
    var checkWidth = (rule, value, callback) => {
      //  );
      if (value === '') {
        callback(new Error('请填写宽度'))
      } else if (this.SpuBarCodeVo.codeType === 'VERTICAL_BAR_CODE' && +value < 24) {
        callback(new Error('宽不能小于24mm'))
      } else
        if (!/^([0-9]+[\d]*(.[0-9]{1})?)$/.test(value)) {
          callback(new Error('输入最多一位小数的数字'))
        } else {
          callback()
        }
      //    else if (+value < 3) {
      //   callback(new Error('宽不能小于3mm'))
      // } 
    }
    var checkHeight = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写高度'))
      } else if (this.SpuBarCodeVo.codeType === 'VERTICAL_BAR_CODE' && +value < 6) {
        callback(new Error('高不能小于6.0mm'))
      } else
        if (!/^([0-9]+[\d]*(.[0-9]{1})?)$/.test(value)) {
          callback(new Error('输入最多一位小数的数字'))
        } else {
          callback()
        }
      //    else if (+value < 2) {
      //   callback(new Error('高不能小于2mm'))
      // } 
    }
    var portrait = (rule, value, callback) => {
      if (this.SpuBarCodeVo.portrait === '') {
        callback(new Error('请选择纵向方向'))
      } else if (this.SpuBarCodeVo.portraitParam === '') {
        callback(new Error('请输入纵向距离'))
      } else if (!/^-?([0-9]+[\d]*(.[0-9]{1,2})?)$/.test(this.SpuBarCodeVo.portraitParam)) {
        callback(new Error('请输入数字,最多两位小数'))
      } else {
        callback()
      }
    }
    var transverse = (rule, value, callback) => {
      if (this.SpuBarCodeVo.transverse === '') {
        callback(new Error('请选择横向方向'))
      } else if (this.SpuBarCodeVo.transverseParam === '') {
        callback(new Error('请输入横向距离'))
      } else if (!/^-?([0-9]+[\d]*(.[0-9]{1,2})?)$/.test(this.SpuBarCodeVo.transverseParam)) {
        callback(new Error('请输入数字,最多两位小数'))
      } else {
        callback()
      }
    }
    return {
      SpuBarCodeVo: {
        fontSize: '32',
        barName: '',
        codeType: '',
        height: '',
        width: '',
        identityImage: '',
        portrait: '',
        portraitParam: '',
        transverse: '',
        transverseParam: ''
      },
      rules: {
        barName: [
          { required: true, message: '请填写码名称', trigger: 'blur' }
        ],
        codeType: [
          { required: true, message: '请选择码类型', trigger: 'change' }
        ],
        width: [
          { validator: checkWidth, trigger: 'blur' }
        ],
        fontSize: [
          { validator: checkSize, trigger: 'blur' }
        ],
        height: [
          { validator: checkHeight, trigger: 'blur' }
        ],
        portrait: [
          { validator: portrait, trigger: 'change' }
        ],
        transverse: [
          { validator: transverse, trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    SpuBarCodeVo: {
      handler (val, oldVal) {
        // console.log(val, '监听')
        if (val.codeType === 'REMARK') {
          val.transverse = 'left'
          val.portrait = 'bottom'
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    if (this.$route.query.id) { this.getCodeMsg() }
  },
  methods: {
    change () {
      // if (this.SpuBarCodeVo.codeType === 'IDENTITY') {
      //   this.SpuBarCodeVo.width = 0
      //   this.SpuBarCodeVo.height = 0
      // } else {
      this.SpuBarCodeVo.width = ''
      this.SpuBarCodeVo.height = ''
      // }
    },
    uploadImg (e) {
      if (e.target.files[0].type !== 'image/jpeg' && e.target.files[0].type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (e.target.files[0].size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(e.target.files[0], this.$store.state.awsSdk.product.s3).then(res => {
        this.SpuBarCodeVo.identityImage = res
      })
    },
    clickInput () {
      document.getElementById('update').click()
    },
    asd () {
    },
    input (e) {
    },
    getCodeMsg () {
      barDetail(this.$route.query.id).then(res => {
        if (res.data.success) {
          let obj = res.data.data
          if (obj.codeType !== 'IDENTITY') {
            obj.identityImage = ''
          }
          this.SpuBarCodeVo = obj
        } else {
          this.$message.error('请求有误')
        }
      })
    },
    saveCode () {
      if (this.SpuBarCodeVo.codeType === 'REMARK') {
        this.SpuBarCodeVo.height = 10
        this.SpuBarCodeVo.width = 10
      }
      if (this.SpuBarCodeVo.codeType !== 'VERTICAL_BAR_CODE' && this.SpuBarCodeVo.codeType !== 'REMARK') {
        this.SpuBarCodeVo.fontSize = 0
      }
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          console.log('进入', this.SpuBarCodeVo)
          return
        }
        if (this.SpuBarCodeVo.codeType === 'IDENTITY' && this.SpuBarCodeVo.identityImage === '') {
          this.$message.error('未上传标识图片')
          return
        }
        if (this.$route.query.id) {
          barUsable({ act: 1, barName: this.SpuBarCodeVo.barName }).then(res => {
            if (!res.data.data.exist) {
              barUpdate({ barCodeId: this.$route.query.id, data: this.SpuBarCodeVo }).then(res => {
                if (res.data.success) {
                  this.$message.success('修改成功')
                  this.$router.go(-1)
                }
              })
            } else {
              this.$message.error('名称重复请重新输入')
              return false
            }
          })
        } else {
          barUsable({ act: 0, barName: this.SpuBarCodeVo.barName }).then(res => {
            if (!res.data.data.exist) {
              console.log(this.SpuBarCodeVo, 'this.SpuBarCodeVo')
              barAdd(this.SpuBarCodeVo).then(res => {
                if (res.data.success) {
                  this.$message.success('添加成功')
                  this.$router.go(-1)
                }
              })
            } else {
              this.$message.error('名称重复请重新输入')
              return false
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.create-com-size {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: auto;

      @{deep} .el-input__inner {
        width: 77px;
      }
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }
}
</style>
